import { Route, Routes } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { PortalApp } from "./portal/PortalApp";

/**
 * The split between the two surfaces this bundle serves.
 *
 * The console's `AuthProvider` is mounted inside its own branch rather than around
 * everything, which is the point of this file: a client user loading `/portal`
 * must not cause a call to `/api/auth/me`, and no portal screen can reach an
 * operator's identity through context because the provider holding it was never
 * rendered above them.
 *
 * `/portal/*` outranks `/*` in react-router's ranking, so the console's catch-all
 * cannot swallow a portal path.
 */
export function Root() {
  return (
    <Routes>
      <Route path="/portal/*" element={<PortalApp />} />
      <Route
        path="/*"
        element={
          <AuthProvider>
            <App />
          </AuthProvider>
        }
      />
    </Routes>
  );
}
